<template>
  <div class="container-list">
    <!-- <div class="common-page common-head ml20">
            <div class="common-page common-head-title ">
                <i class="icon-tr--detailed" style="padding-right: 5px"></i>
                上报火警单位列表
            </div>
           <div class="common-page common-head-end" @click="$router.back()">
               <i class="icon-tr-sign-out"></i>
           </div>   
        </div> -->
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
        <!-- <el-button type="primary" icon="" @click="showDia = true" > 查询</el-button> -->
        <!-- <div class="btn" @click="showDia = true"   ><i class="icon-tr-search"></i></div> -->
        <div class="btn ml20" v-print="'#detailtable'">打印</div>
      </div>
      <div class="common-page common-list" id="printm">
        <!-- <el-table :data="list"  class="mt10">
                    <el-table-column
                            prop="c_name"
                            label="上报单位"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="c_phone"
                            align="center"
                            label="联系电话">
                    </el-table-column>
                    <el-table-column
                            prop="nowtime"
                            align="center"
                            label="上报日期">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            align="center"
                            label="上报内容">
                    </el-table-column>
                     <el-table-column
                            prop="cl_time"
                            align="center"
                            label="处理日期">
                    </el-table-column>
                    <el-table-column
                            prop="cl_yijian"
                            align="center"
                            label="处理内容">
                    </el-table-column>
              
                </el-table> -->
        <table class="table table-bordered " style="width:100%" id="detailtable">
          <thead>
            <tr>
              <th>上报单位</th>
              <th>联系电话</th>
              <th>上报日期</th>
              <th>上报内容</th>
              <th>处理日期</th>
              <th>处理内容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ item.c_name }}</td>
              <td>{{ item.c_phone }}</td>
              <td>{{ item.nowtime }}</td>
              <td>{{ item.remark }}</td>
              <td>{{ item.cl_time }}</td>
              <td>{{ item.cl_yijian }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-pagination background layout="prev, pager, next" :page-size="params.limit || 10" @current-change="pageChange" :total="total"> </el-pagination>
    </div>

    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, editUser } from "../../api/user";
import { get, post } from "@/utils/http.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      params: { page: 1, c_name: "", starttime: "", endtime: "", c_belong_profession: "" },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("jiejingsearch"),
      editData: {},
      remoteFuncs: {
        getSelect(resolve) {
          post("/devicemanage/mapcode", { mc_parent_id: 66 }).then((res) => {
            resolve(res.data);
          });
        },
      },
    };
  },
  computed: {
    ...mapState(["isMute", "isWaring", "jjList", "isLoop", "showFire"]),
  },

  watch: {},
  created() {
    this.getList();
    console.log("finish");
  },
  methods: {
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      this.$post("/user/jjlists", this.params)
        .then((res) => {
          this.total = res.count;
          this.list = res.list;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 8px;
  vertical-align: top;
  text-align: center;
  border-top: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #dddddd;
}

@media print {
  /* #printm{
        width: 900px;
    } */
}
</style>
